import { NodeSpec } from 'prosemirror-model';

import OrderedList from '../OrderedList';

export default class InlineEditorOrderedList extends OrderedList {
  get schema(): NodeSpec {
    return {
      ...this._schema,
      toDOM: (node) => ['ol', { class: 'list-decimal' }, 0],
    };
  }
}
